import { api } from '@/lib/api'
import { defaultPaginationMeta, parseMasterCatalogResponse } from '@/lib/api/masterCatalog'

/** @typedef {import('@/types/api').PaymentMethod} PaymentMethod */

/**
 * @returns {Promise<PaymentMethod[]>}
 */
export async function fetchPosPaymentMethods() {
  const { data } = await api.get('/payment-methods')
  return data.data.payment_methods
}

/**
 * @param {Record<string, unknown>} [params]
 * @returns {Promise<{ items: PaymentMethod[], meta: import('@/types/api').PaginationMeta }>}
 */
export async function fetchPaymentMethodsPage(params = {}) {
  const { data } = await api.get('/masters/payment-methods', { params })
  const parsed = parseMasterCatalogResponse(data, 'payment_methods')
  return {
    items: parsed.items,
    meta: defaultPaginationMeta(parsed.meta ?? {}),
  }
}

/**
 * @param {Record<string, unknown>} [params]
 * @returns {Promise<PaymentMethod[]>}
 */
export async function fetchPaymentMethodsList(params = {}) {
  const { data } = await api.get('/masters/payment-methods', { params })
  return data.data.payment_methods
}

/**
 * @returns {Promise<PaymentMethod[]>}
 */
export async function fetchPaymentMethods() {
  return fetchPaymentMethodsList()
}

/**
 * @param {Partial<PaymentMethod>} payload
 * @returns {Promise<PaymentMethod>}
 */
export async function createPaymentMethod(payload) {
  const { data } = await api.post('/masters/payment-methods', payload)
  return data.data.payment_method
}

/**
 * @param {number} paymentMethodId
 * @param {Partial<PaymentMethod>} payload
 * @returns {Promise<PaymentMethod>}
 */
export async function updatePaymentMethod(paymentMethodId, payload) {
  const { data } = await api.put(`/masters/payment-methods/${paymentMethodId}`, payload)
  return data.data.payment_method
}
